module.exports = __webpack_public_path__ + "media/images/voting_1-d2b143a26fd452d7773eb975a2524c60.svg";